import React from 'react';
import { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import styles from '../orderService/index.module.less'
import {Button, Badge, message} from 'antd'
import {
  SBack,
  SLowcodeList,
  SIDRender,
  STags,
} from 'shj-components'
import config from './config';
import { findResponseListByPage, getEnum, httpCompanyList, findRulesPlanErrCountResponse, updateByIdCustomer } from '@/services/fmsServices'
import { esignCommonList } from '@/services/fmsConfig'
import { getAllCompany } from '@/services/homeService'

export default function PaymentServiceManage ()  {
  const history = useNavigate();
  const [openModal, setModal] = useState(false);
  const [errCount, setErrCount] = useState(0);
  const listRef = useRef<any>();
  useEffect(() => {
    getCount()
  }, [])
  const getCount = () => {
    findRulesPlanErrCountResponse({}).then((res)=>{
      setErrCount(res?.pendingCount)
    })
  }
   // 表格加载
   const fetchList = (values: any) => {
    const { current, pageSize, ...rest } = values;
    const query = {
      ...values.query,
    }
    return new Promise(async (resolve, reject) => {
      try {
        findResponseListByPage(current, pageSize, query).then((res)=>{
          resolve(res)
        })
      } catch (e) {
        reject({ success: false });
      }
    });
  };

  // 右侧表格事件：
  const onAdd = () => {
    setModal(true)
  }
  // 刷新
  const reloadFn = () => {
    const {
      current: { reload },
    } = listRef;
    reload();
  };
  // 更新金蝶
  const [updating, setUpdating] = useState(false);
  const updateCustomers = ({selectedRows}) => {
    setUpdating(true)
    if(!updating){
      const customerIds = selectedRows.map(item => item.customerId)
      updateByIdCustomer(customerIds).then((res) => {
        setUpdating(false)
        message.success(res.message || '更新成功')
        reloadFn()
      }).catch(err=>{
        setUpdating(false)
      })
    }
  }

  const onEdit = (record: any) => {
    // history(`/fms/paymentService/${record?.id}/${record?.orderId}/${record?.dealMode}`)
    window.open(`/fms/paymentService/${record?.id}/${record?.orderId}/${record?.dealMode}`, '_blank')
  }
// 订单状态 需求标签对应文案及样式渲染
const statusShow = (text: any) => {
  switch (text) {
    case '待签约':
      return {
        display: '待签约',
        className: 'waitSignStyle',
      }
    case '待支付':
      return {
        display: '待支付',
        className: 'waitPayStyle',
      }
    case '已生效':
      return {
        display: '已生效',
        className: 'effectiveStyle',
      }
    case '已失效':
      return {
        display: '已失效',
        className: 'expiredStyle',
      }
    case '已退单':
      return {
        display: '已退单',
        className: 'returnOrderStyle',
      }
    case '服务中':
      return {
        display: '服务中',
        className: 'inServiceStyle',
      }
    case '已完成':
      return {
        display: '已完成',
        className: 'completedStyle',
      }
    default:
      return {
        display: '',
        className: '',
      }
  }
}
  const getStatusOptions = () => {
    return new Promise(async resolve => {
      // const demandList = await httpDictServ({parentKey: 'demandKey'}) //需求标签
      const demandList = await getEnum('com.shj.saas.plus.crm.enums.BizOpTypeEnum') //需求标签
      const orderPayStateList = await getEnum('com.shj.saas.plus.fms.enums.OrderAccountPayStateEnum') //支付状态
      const orderStateLists: any = await getEnum('com.shj.saas.plus.trade.enums.OrderStateEnum')
      const orderStateList = orderStateLists.filter(
        item => item.key !== 'expired'
      ) //订单状态，过滤掉已失效
      // const companyList = await httpCompanyList() //门店
      const companyList = await getAllCompany() //门店
      const esignCompanyList = await esignCommonList() //财务主体
      resolve({
        demandList,
        orderPayStateList,
        orderStateList,
        companyList,
        esignCompanyList
      })
    })
  }
  // 右侧表格配置
  const extension = {
    request: { fetchList, getStatusOptions },
    events: { onAdd, updateCustomers},
    // status: {
    //   loading: updating,
    // },
    customRender: {
      clueIdRender(text: any, record: any) {
        return (
          <SIDRender id={text} onClick={() => onEdit(record)} copy={false}></SIDRender>
        )
      },
      statusRender(text: any, record: any) {
        return <p className={styles[statusShow(text).className]}>{statusShow(text).display}</p>
      },
      abnormalErrorList(text: any, record: any){
        return (<Badge count={errCount} offset={[-15, 5]}>
          <Button color={false?'danger':'primary'} variant="link" onClick={()=>history('/fms/paymentService/abnormalList')}>收款计划异常数据</Button> 
        </Badge>
        )
      },
      bizTagRender(text: any, record: any) {
        return <STags itemKey={text} />
      },
    },
  }

  return (
    <div>
      <SBack title="客户收款列表"></SBack>
      <SLowcodeList rowClassName={(record, index)=>{
        if(record?.rulesPlanErrPendingCount > 0){
          return styles.rowRedBackground
        }
      }} config={config} ref={listRef} {...extension} searchMode="group" />
    </div>
  )
}